import React from "react";
import { Box, FormControlLabel, Switch, Typography } from "@mui/material";
import {
  PRODUCT_SURFACE_CATALOG,
  formatProductSurfacesSummary,
  toggleProductSurface,
} from "constants/productSurfaces";

/**
 * Multi-product surface binder for TCI create/edit forms.
 * Uses react-hook-form Controller-compatible value/onChange.
 */
export default function ProductSurfacesField({ value = [], onChange, helperText }) {
  const list = Array.isArray(value) ? value : [];

  const isEnabled = (productId, surfaceId) =>
    list.some((row) => row.productId === productId && row.surfaceId === surfaceId);

  return (
    <Box sx={{ display: "grid", gap: 2 }}>
      <Typography variant="subtitle2">Sub-application surfaces</Typography>
      <Typography variant="body2" color="text.secondary">
        {helperText ||
          "Choose which product surfaces this TCI may read or write. Adapters run when registered; otherwise the binding is declared for future wiring."}
      </Typography>
      {PRODUCT_SURFACE_CATALOG.map((product) => (
        <Box key={product.productId} sx={{ display: "grid", gap: 1 }}>
          <Typography variant="body2" color="text.primary">
            {product.label}
          </Typography>
          {product.surfaces.map((surface) => (
            <FormControlLabel
              key={`${surface.productId}-${surface.surfaceId}`}
              control={
                <Switch
                  checked={isEnabled(surface.productId, surface.surfaceId)}
                  onChange={(event) =>
                    onChange(
                      toggleProductSurface(
                        list,
                        surface.productId,
                        surface.surfaceId,
                        event.target.checked,
                      ),
                    )
                  }
                />
              }
              label={
                <Box>
                  <Typography variant="body2">{surface.label}</Typography>
                  <Typography variant="caption" color="text.secondary">
                    {surface.description}
                    {surface.defaultAdapterKey
                      ? ` · adapter: ${surface.defaultAdapterKey}`
                      : " · declared only"}
                  </Typography>
                </Box>
              }
            />
          ))}
        </Box>
      ))}
      <Typography variant="caption" color="text.secondary">
        {formatProductSurfacesSummary(list)}
      </Typography>
    </Box>
  );
}
